export function StatLabels({
  totalFiles,
  totalDurationSeconds,
  capacityRemainingSeconds,
}: {
  totalFiles: number;
  totalDurationSeconds: number;
  capacityRemainingSeconds: number;
}) {
  return (
    <div className="stat-labels">
      <Stat label="Total files" value={String(totalFiles)} />
      <DurationStat label="Total duration" seconds={totalDurationSeconds} />
      <DurationStat label="Bucket capacity remaining" seconds={capacityRemainingSeconds} />
    </div>
  );
}

function DurationStat({ label, seconds }: { label: string; seconds: number }) {
  const total = Math.max(0, Math.round(seconds));
  const duration = [
    { value: Math.floor(total / 3600), label: "Hours" },
    { value: Math.floor((total % 3600) / 60), label: "Minutes" },
    { value: total % 60, label: "Seconds" },
  ];

  return (
    <div className="duration-stat-card">
      <div className="duration-stat-title">{label}</div>
      <div className="duration-stat-values">
        {duration.map((part) => (
          <div className="duration-stat-part" key={part.label}>
            <b>{String(part.value).padStart(2, "0")}</b>
            <span>{part.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div className="stat-card">
      <div className="text-xs uppercase tracking-wide text-slate-500">{label}</div>
      <div className="mt-1 text-2xl font-semibold text-slate-100">{value}</div>
    </div>
  );
}
